import { Common } from '.'

export const zhSG: Common = {
  entities: {
    form: 'form',
    template: 'template',
    design: 'design',
    link: 'link',
    page: 'page',
    field: 'field',
    changes: 'changes',
    step: 'step',
    paymentProof: 'proof of payment',
    credentials: 'credentials',
    product: 'product',
  },
  save: 'Save',
  create: 'Create',
  removeReenter: 'Remove and re-enter',
  share: 'Share',
  cancel: 'Cancel',
  title: 'Title',
  option: 'Option',
  optional: 'optional',
  maximum: 'Maximum',
  minimum: 'Minimum',
  exact: 'Exact',
  delete: 'Delete',
  back: 'Back',
  edit: 'Edit',
  loading: 'Loading',
  saving: 'Saving',
  responses: 'Responses',
  feedback: 'Feedback',
  verify: 'Verify',
  verified: 'Verified',
  goToDashboardCta: 'Go to dashboard',
  download: 'Download',
  default: 'Default',
  errors: {
    required: 'This field is required',
    validValue: 'Please enter a valid {fieldName}',
    image: {
      notProvided: 'Image not provided',
    },
    validation: {
      mobileNoVerification: 'Please verify your mobile number',
      emailVerification: 'Please verify your email address',
      homeNo: 'Please enter a valid landline number',
    },
    pageNotFound: 'This page could not be found.',
  },
  tooltip: {
    deleteField: 'Delete field',
    duplicateField: 'Duplicate field',
  },
  dropdown: {
    placeholder: 'Select an option',
  },
  days: {
    Mondays: 'Monday',
    Tuesdays: 'Tuesday',
    Wednesdays: 'Wednesday',
    Thursdays: 'Thursday',
    Fridays: 'Friday',
    Saturdays: 'Saturday',
    Sundays: 'Sunday',
  },
  today: 'today',
  tomorrow: 'tomorrow',
  yesterday: 'yesterday',
  formStatus: {
    closed: 'Closed',
    open: 'Open',
  },
  responseMode: {
    email: 'Email mode',
    storage: 'Storage mode',
  },
  formName: 'Form name',
}
